import React from "react";
import { withTranslation } from 'react-i18next';
import {
  registerQuickAddAutoComplete,
  quickAddEventHandler,
  getUserId,
  getWsTagId,
  removeEmojiContent
} from "../../utils/common";

import CommonTags, {
  autoResizeTextArea,
  resetTextAreaHeight
} from "./commonTags";
import { nowToUnix } from "../../apps/meetings/utils/dates";

// Sub text area of takeaway for click 1st
class PostTopicSubTakeawaysNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "take",
      tag: 0,
      act: "add",
      showDoneBtn: 1,
      pointerEvents: 'unset',
      addNewTakeaway: true
    };
    this.saveRelTake = this.saveRelTake.bind(this);
    this.submitRelTake = this.submitRelTake.bind(this);
    this.addRelTake = this.addRelTake.bind(this);
    this.afterSaveTake = this.afterSaveTake.bind(this);
    this.handleNewDescChange = this.handleNewDescChange.bind(this);
    this.getReturnTag = this.getReturnTag.bind(this);
    this.subTakeLiveSync = this.subTakeLiveSync.bind(this);
    this.closeTextAreaField = this.closeTextAreaField.bind(this);
    this.selectArea = this.selectArea.bind(this);
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    const { userPermission, meetingObj, topicId } = this.props;
    if (
      typeof userPermission.execute !== "undefined" &&
      userPermission.execute == "1"
    ) {
      registerQuickAddAutoComplete(`#meeting_take_${meetingObj.id}_${topicId}`);
    }

    // window.addEventListener("click", this.saveRelTake, true);

    const eleId = `meeting_take_${meetingObj.id}_${topicId}`;
    initializeMeetingEditor(eleId, this.submitRelTake);
    // $(`#${eleId}`).trigger("focus");
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    // window.removeEventListener("click", this.saveRelTake, true);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    const { addNewTakeaway } = this.state
    const { meetingObj, topicId } = this.props

    const targetClassList = event.target.classList
    const clickedOnTooltip = targetClassList.contains('ui-tooltip-content') || targetClassList.contains('ui-tooltip')

    const id = `meeting_take_${meetingObj.id}_${topicId}`
    const linkPopup = $(`.cke_editor_${id}_dialog`)

    if (
      addNewTakeaway
      && this.wrapperRef
      && !this.wrapperRef.current.contains(event.target)
      && (linkPopup.length == 0 || (linkPopup.length > 0 && linkPopup.css('display') == 'none'))
      && !clickedOnTooltip
    ) {
      this.submitRelTake(event);

      if ($('.mention-suggestions').length > 0 && $(event.currentTarget.activeElement).parents('.cke').length < 1) {
        $('.mention-suggestions').remove();
        $('.mention-suggestions-div').remove();
      }
    }
  }

  saveRelTake(e) {
    const empTakeContainer = $(
      `#meeting_take_${this.props.meetingObj.id}_${this.props.topicId}`
    );
    const agendaSearchContainer = $(".agenda-autosearch");
    const tagListContainer = $(".meeting-tag-wrapper");
    let ckEditorFlag = !$(empTakeContainer).is(e.target) && $(empTakeContainer).has(e.target).length === 0;
    let takeawayCKEditorInput = $(`#cke_meeting_take_${this.props.meetingObj.id}_${this.props.topicId}`);
    if (takeawayCKEditorInput != undefined) {
      let takeawayCKEditorInputValue = $(`#cke_meeting_take_${this.props.meetingObj.id}_${this.props.topicId}` + ' iframe').contents().find('body').html();
      if ($(takeawayCKEditorInputValue).text() == '') {
        takeawayCKEditorInputValue = '';
      }
      empTakeContainer.val(takeawayCKEditorInputValue);
      ckEditorFlag = !$(takeawayCKEditorInput).is(e.target) &&
        $(takeawayCKEditorInput).has(e.target).length === 0;
    }
    // adding a more reliable way to track click vs drag (mousedown/mouseup)
    let highlightedText = "";
    if (window.getSelection) {
      highlightedText = window.getSelection().toString();
    } else if (document.selection && document.selection.type != "Control") {
      highlightedText = document.selection.createRange().text;
    }
    if (highlightedText != "") {
      return;
    } else {
      if (
        ckEditorFlag &&
        (!$(agendaSearchContainer).is(e.target) &&
          $(agendaSearchContainer).has(e.target).length === 0) &&
        (!$(tagListContainer).is(e.target) &&
          $(tagListContainer).has(e.target).length === 0)
      ) {
        const fieldObj = $(this.refs.meeting_topic_new);
        const takeText = $.trim($(fieldObj).val());
        if (
          $(fieldObj)
            .text()
            .trim().length == 0
        ) {
          this.afterSaveTake();
          return;
        }
        this.addRelTake(takeText);
      } else if (empTakeContainer.parents(".meeting_take_sortable").length) {
        empTakeContainer
          .parents(".meeting_take_sortable")
          .removeClass("bgwhite");
      }
    }
  }

  submitRelTake(e) {
    this.setState({
      pointerEvents: 'none'
    })
    const empTakeContainer = $(
      `#meeting_take_${this.props.meetingObj.id}_${this.props.topicId}`
    );
    let takeawayCKEditorInput = $(`#cke_meeting_take_${this.props.meetingObj.id}_${this.props.topicId}`);
    if (takeawayCKEditorInput != undefined) {
      let takeawayCKEditorInputValue = $(`#cke_meeting_take_${this.props.meetingObj.id}_${this.props.topicId}` + ' iframe').contents().find('body').html();
      if ($(takeawayCKEditorInputValue).text() == '') {
        takeawayCKEditorInputValue = '';
      }
      empTakeContainer.val(takeawayCKEditorInputValue);
    }
    const fieldObj = $(this.refs.meeting_topic_new);
    const subActText = $.trim($(fieldObj).val());
    const quickAddAI = $(fieldObj).data("quickAddAI");
    // if (
    //   (((e.ctrlKey || e.metaKey) && e.keyCode == 83) ||
    //     (e.keyCode == 13 && quickAddAI == true)) &&
    //   $(fieldObj)
    //     .text()
    //     .trim().length != 0
    // ) {
    //   e.preventDefault();
    this.addRelTake(subActText);
    // }
  }

  addRelTake(takeDesc, updatedS3Data) {
    const topicRelId = this.props.topicId;
    const { currentUser } = this.props;
    const fname = currentUser.firstname;
    const lname = currentUser.lastname;
    const { meetingObj } = this.props;
    const meetingId = meetingObj.id;
    const fieldObj = $(this.refs.meeting_topic_new);
    const { actions } = this.props;
    const { tag } = this.state;

    let rowIndex = 1;
    const divRelCount = $(`.relTopicTakeList_${topicRelId}`).length;
    if (divRelCount == 0) {
      rowIndex = rowIndex;
    } else {
      rowIndex = divRelCount;
    }
    const fieldId = `#meeting_take_${meetingId}_${topicRelId}`;
    let quickAddAI = true; //$(fieldObj).data("quickAddAI");
    const meetingWsId = this.props.meetingObj.ws_id;
    if (
      quickAddAI == true &&
      !takeDesc.match(/#(.*)#/) &&
      !takeDesc.match(/@(.*)@/) &&
      !takeDesc.match(/(\!)(\d)+(\?)*/g)
    ) {
      quickAddAI = false;
    }
    if (quickAddAI == true && takeDesc.match(/@(.*)@/) && !takeDesc.match('data-userid')) {
      quickAddAI = false;
    }
    if (quickAddAI == true && takeDesc.match(/#(.*)#/) && !takeDesc.match('data-quickaddtagid')) {
      quickAddAI = false;
    }
    const quickAddAIParams = {};
    if (quickAddAI == true) {
      const isvalid = quickAddEventHandler(fieldObj);
      if (!isvalid) {
        return;
      }
      quickAddAIParams.tagId = getWsTagId(takeDesc);
      if (
        quickAddAIParams.tagId == "" ||
        typeof quickAddAIParams.tagId === "undefined"
      ) {
        quickAddAIParams.tagId = meetingWsId;
      }
      quickAddAIParams.userId = getUserId(takeDesc);
    }
    if (updatedS3Data) {
      actions.UpdateMeetingS3Data("mtS3Data", updatedS3Data);
    }
    if ($(fieldId).parents(".meeting_take_sortable").length) {
      $(fieldId)
        .parents(".meeting_take_sortable")
        .removeClass("bgwhite");
    }
    const takeawayId = `meeting_take_${meetingId}_${topicRelId}`;
    let mainText = "";
    if (takeawayId) {
      let insta = CKEDITOR.instances[takeawayId];
      if (insta) {
        mainText = removeEmojiContent(CKEDITOR.instances[takeawayId].getData().trim());
      }
    }
    if (
      mainText
        .trim().length == 0 || $('#cke_' + takeawayId + ' iframe').contents().find('body').text() == ''
    ) {
      this.afterSaveTake();
      return;
    }
    this.setState({ addNewTakeaway: false }, () => {
      this.props.saveMeetingTakeAway(
        takeDesc,
        meetingId,
        tag,
        nowToUnix(),
        fname,
        lname,
        topicRelId,
        quickAddAI,
        quickAddAIParams,
        this.afterSaveTake
      );
    })
  }

  afterSaveTake(takeId, takeDesc) {
    this.setState({
      showDoneBtn: 0,
      addNewTakeaway: true
    });
    this.setState({
      pointerEvents: 'unset'
    });
    this.props.closeTextArea();
  }

  handleNewDescChange(e) {
    const tag = $(e.target)
      .closest(".wb-item-selector")
      .find(".meeting-tag-options")
      .attr("data-tag");
    this.setState({ desc: e.target.value, tag });
  }

  getReturnTag(tagId) {
    this.setState({
      tag: tagId
    });
  }

  subTakeLiveSync() {
    const { meetingObj, topicId } = this.props;
    // Notify typing event
    if (!getMeetingTyping()) {
      typing("meet");
      setMeetingTyping(true);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        typingTimeOut("meet");
      }, 3500);
    }
    // if user is typing and both the users are active in meeting, then display the warning
    if ($("#typing-alert").css("display") == "none") {
      // element is hidden
      $(".topic-alert")
        .delay(100)
        .fadeOut();
    } else {
      $(".topic-alert")
        .delay(500)
        .fadeIn();
    }

    const eleId = `meeting_take_${meetingObj.id}_${topicId}`;
    autoResizeTextArea({ eleId: `#${eleId}` });
    this.setState({
      showDoneBtn: 1
    });
  }

  closeTextAreaField() {
    console.log("closeTextAreaField invoked from postTopicSubTakeawaysNotes");
    const { meetingObj, topicId } = this.props;
    this.props.closeTextArea();
    const eleId = `meeting_take_${meetingObj.id}_${topicId}`;
    resetTextAreaHeight({ eleId: `#${eleId}` });

    if ($(`#${eleId}`).parents(".meeting_take_sortable").length) {
      $(`#${eleId}`)
        .parents(".meeting_take_sortable")
        .removeClass("bgwhite");
    }
    this.setState({
      showDoneBtn: 0
    });
  }

  selectArea(e) {
    const { meetingObj, topicId } = this.props;
    e.preventDefault();

    const eleId = `meeting_take_${meetingObj.id}_${topicId}`;
    autoResizeTextArea({ eleId: `#${eleId}` });
    if ($(`#${eleId}`).parents(".meeting_take_sortable").length) {
      $(`#${eleId}`)
        .parents(".meeting_take_sortable")
        .addClass("bgwhite");
    }
  }

  render() {
    const { topicId } = this.props;
    const { meetingObj } = this.props;
    const color = "#FFFFFF";
    const textareaId = `meeting_take_${meetingObj.id}_${topicId}`;
    return (
      <div
        className="wb-table-row wb-item-selector subtakeawayNotes "
        data-tag={this.state.tag}
        data-type="take"
      >
        <div className="wb-mbox" ref={this.wrapperRef}>
          <div className="wb-table tabLayFix">
            <div className="wb-table-col wb-table-col-tag takeawayFirstSection" >
              <CommonTags
                owner={this.props.currentUser.id}
                key={`topic_${topicId}`}
                meeting={meetingObj}
                currentUser={this.props.currentUser}
                userPermission={this.props.userPermission}
                tag={this.state.tag}
                type={this.state.type}
                saveTags={this.props.saveTags}
                getReturnTag={this.getReturnTag}
              />
            </div>

            <div className="wb-table-col wb-table-col-title clickable wb-table-col-edit-title  ">
              <div className="textAlignLeft">
                <div
                  // contentEditable="true"
                  data-enable-quickadd="true"
                  id={textareaId}
                  className="meetingagendatextbox "
                  placeholder=""
                  ref="meeting_topic_new"
                  style={{ backgroundColor: color }}
                  onClick={e => this.selectArea(e)}
                  onKeyPress={event => this.subTakeLiveSync(event)}
                  onKeyDown={event => this.submitRelTake(event)}
                  onPaste={event => this.subTakeLiveSync(event)}
                />
              </div>
            </div>
          </div>
          {this.state.showDoneBtn ? (
            <button
              onClick={e => this.submitRelTake(e)}
              className="btn-circle subTakeBtn"
              style={{ marginTop: '-51px', pointerEvents: this.state.pointerEvents }}
            >
              <span className="icon icon-outline-check-24px-blue"></span>
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
export default withTranslation()(PostTopicSubTakeawaysNotes);
